import React from "react";
import TopNav from "@/components/landing/TopNav";
import Hero from "@/components/landing/Hero";
import ProphetPinnedWhisper from "@/components/landing/ProphetPinnedWhisper";
import Manifesto from "@/components/landing/Manifesto";
import VaultSection from "@/components/landing/vault/VaultSection";
import ProphetChat from "@/components/landing/ProphetChat";
import PropheciesFeed from "@/components/landing/PropheciesFeed";
import Mission from "@/components/landing/Mission";
import Tokenomics from "@/components/landing/Tokenomics";
import TransparencyTimeline from "@/components/landing/TransparencyTimeline";
import ROISimulator from "@/components/landing/ROISimulator";
import Roadmap from "@/components/landing/Roadmap";
import { TwoTracksRoadmap } from "@/components/landing/TwoTracksRoadmap";
import BrutalTruth from "@/components/landing/BrutalTruth";
import FAQ from "@/components/landing/FAQ";
import Whitelist from "@/components/landing/Whitelist";
import Socials from "@/components/landing/Socials";
import Footer from "@/components/landing/Footer";
import DeepStateIntro from "@/components/intro/DeepStateIntro";
import MissionsSection from "@/components/landing/MissionsSection";

export default function Landing() {
  return (
    <div className="relative">
      <DeepStateIntro />
      <TopNav />
      <main>
        <Hero />
        <ProphetPinnedWhisper />
        <Manifesto />
        <VaultSection />
        <ProphetChat />
        <PropheciesFeed />
        <Mission />
        <Tokenomics />
        {/* Sprint 19 \u2014 Missions Hub teaser (before TransparencyTimeline
            because Mission/Tokenomics establish "what" then Missions
            tells "how to earn", before the roadmap shows "when"). */}
        <MissionsSection />
        <TransparencyTimeline />
        <ROISimulator />
        {/* Sprint 20 — Two-tracks lead-in (Products / Secret project) */}
        <TwoTracksRoadmap />
        <Roadmap />
        <BrutalTruth />
        <FAQ />
        <Whitelist />
        <Socials />
      </main>
      <Footer />
    </div>
  );
}
